import React from 'react'
import { I18n } from '@front/volcanion'

import { GridStepper, SubmitButton } from '@front/squirtle'
import { Box, Grid, Step, Fade } from '@mui/material'

import OrderHeader from '@abra/elements/headers/Order'
import FormSpeedDial from '@abra/elements/speedDial/Form'

import { GridMarginLeft } from './Grid/'
import {
  AddressSection,
  BillingSection,
  ClientSection,
  DateTimeSection,
  DriverInfoSection,
  EstimationSection,
  HistorySection,
  MapSection,
  OptionsSection,
  PackageSection,
  PaymentSection,
  RidemodeDurationSection
} from './Section'

import Dialogs from './Popup'

const OrderDetails = props => {
  const {
    isReadOnly,
    isManagingRecord,
    record_id,
    driver_id,
    commercial_package,
    canOrangeWait,
    disableHeader,
    disableHistory,
    headerLabelProps,
    handleInvoiceDownload,
    handleClickCallCenter,
    handleClickMap,
    handleNewOrder,
    handleWaitingOrange,
    handleOpenSendCommentDialog,
    handleOpenManualDispatch,
    handleOpenSendMessageDriver,
    handleOpenRedispatch,
    handleOpenClaimRedispatch,
    handleOpenSimulator,
    handleCancel,
    handleOrderCopy,
    destination_enabled,
    duration_enabled,
    disabledSubmitButton,
    isEstimationLoading,
    canCancel,
    displayDownloadBillingButton,
    displayOpenSimulatorButton,
    handleOpenNotifyDrivers,
    canCreate,
    canModify,
    canSendMessage,
    canManualDispatch,
    openDialog,
    canNotifyDrivers
  } = props


  const actions = [
    { name: I18n.t('order.new'), onClick: handleNewOrder, iconName: 'add', hidden: !(!!isManagingRecord && !!isReadOnly) || !canCreate },
    { name: I18n.t('central.label', { count: 1 }), onClick: handleClickCallCenter, iconName: 'call', hidden: !!isManagingRecord },
    { name: I18n.t('confirm.waiting'), onClick: handleWaitingOrange, iconName: 'phone_paused', hidden: !canOrangeWait },
    { name: I18n.t('action.clone'), onClick: handleOrderCopy, iconName: 'content_copy', hidden: !isManagingRecord || !canCreate },
    { name: I18n.t('map.label', { count: -1 }), onClick: handleClickMap, iconName: 'map_outlined', hidden: !isManagingRecord },
    { name: I18n.t('action.notify_driver'), onClick: handleOpenNotifyDrivers, iconName: 'campaign', hidden: !canNotifyDrivers },
    { name: I18n.t('comment.label', { count: 1 }), onClick: handleOpenSendCommentDialog, iconName: 'insert_comment', hidden: !isManagingRecord || !canModify },
    { name: I18n.t('driver.message'), onClick: handleOpenSendMessageDriver, iconName: 'forum', hidden: !driver_id || !canSendMessage },
    { name: I18n.t('action.redispatch'), onClick: handleOpenRedispatch, iconName: 'refresh', hidden: !driver_id || !canModify },
    { name: I18n.t('action.claim'), onClick: handleOpenClaimRedispatch, iconName: 'accessibility_new', hidden: !isManagingRecord || !canModify },
    { name: I18n.t('action.manual_dispatch'), onClick: handleOpenManualDispatch, iconName: 'accessibility_new', hidden: !isManagingRecord || !canModify || !canManualDispatch },
    { name: I18n.t('billing.label.alter'), onClick: handleInvoiceDownload, iconName: 'description', hidden: !(!!isManagingRecord && !!isReadOnly && !!displayDownloadBillingButton) },
    { name: I18n.t('action.simulator'), onClick: handleOpenSimulator, iconName: 'smartphone', hidden: !displayOpenSimulatorButton || !canModify },
    { name: I18n.t('action.cancel'), onClick: () => handleCancel(false), iconName: 'do_not_disturb', iconColor: 'error', hidden: !(!!isManagingRecord && !!isReadOnly) || !canCancel },
    { name: I18n.t('action.identifier_pin'), onClick: () => openDialog('identifier_pin_form'), iconName: 'lock_person', hidden: !!isManagingRecord }
  ]

  return (
    <Fade in timeout={2000}>
      <Box>
        <Dialogs handleOpenManualDispatch={handleOpenManualDispatch} handleCancel={handleCancel} />
        <Box sx={{ display: '-webkit-inline-box' }}>
          <Grid container rowSpacing={1}>
            <Grid container size={12}>
              <Grid hidden={isReadOnly} size={12}>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                  <SubmitButton
                    loading={!!isEstimationLoading}
                    disabled={disabledSubmitButton}
                    label={I18n.t('action.save')}
                  />
                </Box>
              </Grid>
              <Grid container size={12}>
                <Grid size={0.8}>
                  <GridMarginLeft  {...props} />
                </Grid>
                <Grid size={11.2}>
                  <Grid hidden={!isManagingRecord || !!disableHeader} size={12}>
                    <OrderHeader order_id={record_id} headerLabelProps={headerLabelProps} />
                  </Grid>
                  <GridStepper connector={<></>} groupsCount={[4]} activeStep={0} orientation="vertical" getStepProps={(index, group) => ({ active: (group !== 1 || index !== 3) || !!isManagingRecord })}>
                    <Step> <ClientSection />  </Step>
                    <Step> <DateTimeSection /> </Step>
                    <Step> <AddressSection prefix='source' /> </Step>
                    <Step>
                      {!!destination_enabled && <AddressSection prefix='destination' />}
                      {!!duration_enabled && <RidemodeDurationSection />}
                    </Step>
                    <Step> <PaymentSection /> </Step>
                    <Step> <PackageSection /> </Step>
                    <Step> <OptionsSection /> </Step>
                  </GridStepper>
                </Grid>
              </Grid>
            </Grid>

            <Grid size={12}>
              <Box sx={{ ml: 4, mt: 4 }}>
                <Grid container spacing={2} rowSpacing={2}>
                  <Grid hidden={!isManagingRecord} size={6}><BillingSection /></Grid>
                  <Grid size={6}>
                    <Grid container rowSpacing={2}>
                      <Grid hidden={!commercial_package} size={12}><EstimationSection /></Grid>
                      <Grid hidden={!isManagingRecord} size={12}><DriverInfoSection /></Grid>
                    </Grid>
                  </Grid>
                  <Grid hidden={!isManagingRecord || !!disableHistory} size={12}><HistorySection /></Grid>
                  <Grid hidden={!isManagingRecord || !!disableHistory} size={12}>
                    <Box sx={{ p: 1, boxShadow: 6, borderRadius: 1 }}>
                      <MapSection record_id={record_id} />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>

          <FormSpeedDial actions={actions} />
        </Box>
      </Box>
    </Fade>
  );
}

export default React.memo(OrderDetails)
